import { useTheme } from '@material-ui/core/styles';
import { getThemeProps } from '@material-ui/styles';

export const Themes = {
  OMQ: 'OMQ',
  USERLIKE: 'USERLIKE',
  MAPP: 'MAPP',
};

// return name of current theme
export function useThemeName(): string {
  const theme = useTheme();
  const { name } = getThemeProps({
    name: 'meta',
    props: {},
    theme,
  }) as { name: string };

  return name;
}
